import React, {Component} from 'react'

import Button from '../atom/Button'
import Select from '../form/Select'
import Text from '../form/Text'
import Title from '../atom/Title'

import { Link } from 'react-router-dom'
import Footer from '../molecule/Footer'

class Form extends Component {

    constructor(props) {
        super(props)
        this.state = {
            formData: {
                first_name: '',
                last_name: '',
                birthday: '',
                birth_city: '',
                address: '',
                city: '',
                zip_code: '',
                reason: ''
            },
            url: false,
        }
    }

    handleChange = e => {
        const {formData} = this.state;
        const target = e.target;
        const name = target.name;
        formData[name] = target.value;
        this.setState(formData);
    }

    createUrl = e => {
        e.preventDefault()
        this.setState({url: true})
    }

    GenerateLink = () => {
        const {first_name, last_name, birthday, birth_city, address, city, zip_code, reason} = this.state
        const link = `/generate?first_name=${first_name}&last_name=${last_name}&birthday=${birthday}&birth_city=${birth_city}&address=${address}&city=${city}&zip_code=${zip_code}&reason=${reason}`

        return(
            <Link className="link_shortcut" to={link}> Générer mon raccourci </Link>
        )
    }

    render() {

        const reasons = {
            work: "Travail",
            buy: "Courses / Achats",
            medic: "Médical",
            family: "Familial impérieux",
            handicap: "Aide à personne en situation d'handicap",
            sport: "Activité sportive 1h",
            admin: "Judiciaire / Administratif",
            public_work: "Travaux d'intérêt généraux",
            school: "Aller chercher les enfants à l'école"
        }

        // const conditions = {
        //     '#first_name': {
        //         length: 1,
        //     },
        //     '#last_name': {
        //         length: 1,
        //     },
        //     '#birthday': {
        //         pattern: /^([0][1-9]|[1-2][0-9]|30|31)\/([0][1-9]|10|11|12)\/(19[0-9][0-9]|20[0-1][0-9]|2020)/g,
        //     },
        //     '#birth_city': {
        //         length: 1,
        //     },
        //     '#address': {
        //         length: 1,
        //     },
        //     '#city': {
        //         length: 1,
        //     },
        //     '#zip_code': {
        //         pattern: /\d{5}/g,
        //     },
        //     '#reason': {
        //         length: 1
        //     }
        // }

        const {url} = this.state

        return(
            <div className="form">
                <Title title="AutoTTESTATION" text="Remplis le formulaire une fois pour créer ton générateur d'attestation personnalisé"/>
                <form onSubmit={this.createUrl} className="formContainer">
                    <Select reason={this.state.formData.reason ? reasons[this.state.formData.reason] : ''} handleChange={this.handleChange} name="reason"/>
                    <Text onChange={this.handleChange} value={this.state.formData.first_name} placeholder="Prénom" id="first_name" />
                    <Text onChange={this.handleChange} value={this.state.formData.last_name} id="last_name" placeholder="Nom de famille"/>
                    <Text onChange={this.handleChange} value={this.state.formData.birthday} id="birthday" placeholder="Date de naissance 01/01/2020"/>
                    <Text onChange={this.handleChange} value={this.state.formData.birth_city} id="birth_city" placeholder="Ville de naissance"/>
                    <Text onChange={this.handleChange} value={this.state.formData.address} id="address" placeholder="Adresse"/>
                    <Text onChange={this.handleChange} value={this.state.formData.city} id="city" placeholder="Ville"/>
                    <Text onChange={this.handleChange} value={this.state.formData.zip_code} id="zip_code" placeholder="Code postal"/>
                    <Button onClick={this.createUrl} text="Créer mon lien d'attestation"/>
                </form>
                {
                    url ? <this.GenerateLink/> : ''
                }
                <Footer/>
            </div>
        )
    }
}

export default Form